import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '../../../components/shared';

interface BalanceCardsProps {
  isAdmin: boolean;
  mainBalance: string;
  pendingBalance: string;
  totalPendingBalance: string;
}

const BalanceCards: React.FC<BalanceCardsProps> = ({
  isAdmin,
  mainBalance,
  pendingBalance,
  totalPendingBalance,
}) => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {!isAdmin && (
        <Card className="shadow-lg">
          <CardContent className="p-4">
            <div className="flex items-center justify-between mb-2">
              <h3 className="text-base font-semibold text-gray-900">
                {t('billing.balance.main')}
              </h3>
              <span className="text-xl">💰</span>
            </div>
            <div
              className={`text-2xl font-bold mb-1 ${
                parseFloat(mainBalance) >= 0 ? 'text-green-600' : 'text-red-600'
              }`}
            >
              {mainBalance}&nbsp;₽
            </div>
            <p className="text-xs text-gray-500">
              {t('billing.balance.title')}
            </p>
          </CardContent>
        </Card>
      )}

      <Card className={`shadow-lg ${!isAdmin ? '' : 'md:col-span-2'}`}>
        <CardContent className="p-4">
          <div className="flex items-center justify-between mb-2">
            <h3 className="text-base font-semibold text-gray-900">
              {t('billing.pendingDeposits')}
            </h3>
            <span className="text-xl">⏳</span>
          </div>
          <div className="text-2xl font-bold text-orange-600 mb-1">
            {isAdmin ? totalPendingBalance : pendingBalance}&nbsp;₽
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default BalanceCards;
